import { useSelector } from 'react-redux';
import { PATAGONIA_ADD_PANEL_SUB_CATEGORIES } from 'ContentEditorUI/constants/Sidebar';
import { getSavedSections, getThemelessSections } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import InpageSavedSectionsContainer from './InpageSavedSectionsContainer';
import { getCanUseContentEmbedFeature } from 'ContentEditorUI/redux/selectors/authSelectors';
import { Fragment, useMemo } from 'react';
import InpageThemelessSectionsContainer from './InpageThemelessSectionsContainer';
import InpageThemeSectionsContainer from './InpageThemeSectionsContainer';
import { getThemePath } from 'ContentEditorUI/redux/selectors/themeSelectors';
// @ts-expect-error not typed
import EditorConfigSingleton from 'ContentEditorUI/EditorConfigSingleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const {
  SAVED,
  THEME,
  NO_THEME
} = PATAGONIA_ADD_PANEL_SUB_CATEGORIES.SECTIONS;
const InpageSectionsContainer = ({
  onDragStart,
  onDragEnd
}) => {
  var _EditorConfigSingleto, _addSidebarConfig$def, _addSidebarConfig$hid, _addSidebarConfig$hid2;
  const savedSections = useSelector(getSavedSections);
  const themelessSections = useSelector(getThemelessSections);
  const themePath = useSelector(getThemePath);
  const canUseContentEmbedFeature = useSelector(getCanUseContentEmbedFeature);
  const addSidebarConfig = ((_EditorConfigSingleto = EditorConfigSingleton.get('inpage')) === null || _EditorConfigSingleto === void 0 ? void 0 : _EditorConfigSingleto.addSidebar) || null;
  const sectionSubCategoriesConfig = (addSidebarConfig === null || addSidebarConfig === void 0 || (_addSidebarConfig$def = addSidebarConfig.defaultSubCategoryMap) === null || _addSidebarConfig$def === void 0 ? void 0 : _addSidebarConfig$def.SECTIONS) || null;
  const hideTags = (_addSidebarConfig$hid = addSidebarConfig === null || addSidebarConfig === void 0 ? void 0 : addSidebarConfig.hideTags) !== null && _addSidebarConfig$hid !== void 0 ? _addSidebarConfig$hid : false;
  const sectionTypeOrder = useMemo(() => {
    if (sectionSubCategoriesConfig) {
      return sectionSubCategoriesConfig;
    } else if (savedSections.length > 0) {
      if (canUseContentEmbedFeature && themelessSections.length > 0) {
        return [SAVED, THEME, NO_THEME];
      }
      return [SAVED, THEME];
    } else {
      if (canUseContentEmbedFeature && themelessSections.length > 0) {
        return [THEME, NO_THEME, SAVED];
      }
      return [THEME, SAVED];
    }
  }, [savedSections, themelessSections, canUseContentEmbedFeature, sectionSubCategoriesConfig]);
  const hideAccordionWithOneSubCategory = (_addSidebarConfig$hid2 = addSidebarConfig === null || addSidebarConfig === void 0 ? void 0 : addSidebarConfig.hideAccordionWithOneSubCategory) !== null && _addSidebarConfig$hid2 !== void 0 ? _addSidebarConfig$hid2 : false;
  const shouldHideAccordion = hideAccordionWithOneSubCategory && sectionTypeOrder.length === 1;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: sectionTypeOrder.map(sectionType => {
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [sectionType === THEME && /*#__PURE__*/_jsx(InpageThemeSectionsContainer, {
          onDragStart: onDragStart,
          onDragEnd: onDragEnd,
          themePath: themePath || '',
          showAccordion: !shouldHideAccordion,
          showTags: !hideTags
        }), sectionType === SAVED && /*#__PURE__*/_jsx(InpageSavedSectionsContainer, {
          onDragStart: onDragStart,
          onDragEnd: onDragEnd,
          themePath: themePath || ''
        }), canUseContentEmbedFeature && sectionType === NO_THEME && /*#__PURE__*/_jsx(InpageThemelessSectionsContainer, {
          onDragStart: onDragStart,
          onDragEnd: onDragEnd
        })]
      }, sectionType);
    })
  });
};
export default InpageSectionsContainer;